/* Swiper-like slider drawn with CSS only: what a SwiperComponent renders on the server and until it mounts, so
   without JavaScript (or before hydration) the slider already looks like its Swiper. It takes the props the
   SwiperComponent receives (slidesPerView, spaceBetween, breakpoints, grid).
   Union of isource / tsco-glass `components/static-slider.js` and jument `components/ui/static-slider.jsx`
   (jument added the pagination placeholder). Server-safe on purpose: no hooks and no "use client".
   The other approach (style Swiper's own markup until it starts, mahya-tajhiz-website) is `swiper_layout`,
   re-exported here. */
import { static_slider_css, static_slider_id } from "@core/helpers/slider-layout";

export { swiper_layout, max_slides_per_view, static_slider_css, static_slider_id } from "@core/helpers/slider-layout";

export default function StaticSlider({
	slides = [],
	slidesPerView,
	spaceBetween,
	breakpoints,
	grid,
	className = "",
	dir,
	// jument: an empty, in-flow box where Swiper's dots will be, so nothing below jumps when they arrive (CLS)
	pagination = false,
	hidePaginationOnDesktop = false,
	pagination_className = "static-slider-pagination",
	hide_pagination_on_desktop_className = "lg:hidden",
	wrapper_className = "relative swiper-main-wrapper",
	slide_className,
}) {
	const config = { slidesPerView, spaceBetween, breakpoints, grid };
	const id = static_slider_id(config);

	return (
		<div className={wrapper_className}>
			<style>{static_slider_css(id, config)}</style>
			<div className={`${id} ${className}`} dir={dir}>
				{(slides || []).map((slide, index) => (
					<div key={`static-slide-${index}`} className={slide_className}>
						{slide}
					</div>
				))}
			</div>
			{pagination && (
				<div
					className={`${pagination_className} ${hidePaginationOnDesktop ? hide_pagination_on_desktop_className : ""}`}
					aria-hidden="true"
				/>
			)}
		</div>
	);
}
